import i18n from "intl/i18n"
import dayjs, { Dayjs } from "utils/dayjs"

import { Guid } from "@/types"

export enum RentToBuyChangeType {
    newInActive = "newInActive",
    periodChange = "periodChange",
    purposeChange = "purposeChange",
    rentalStageOver = "rentalStageOver",
    excessiveRentalRate = "excessiveRentalRate"
}

export interface IGetRentToBuyChangeDTO {
    id: Guid
    changeType: RentToBuyChangeType
    changeDate: string
    approved: boolean
    approvedByUserId?: Guid | null
    approvedDate?: string | null
}

export default class RentToBuyChange {
    id: Guid
    changeType: RentToBuyChangeType
    changeDate: Dayjs
    approved: boolean
    approvedByUserId?: Guid | null
    approvedDate?: Dayjs | null

    constructor(dto: IGetRentToBuyChangeDTO) {
        this.id = dto.id
        this.changeType = dto.changeType
        this.changeDate = dayjs(dto.changeDate)
        this.approved = dto.approved
        this.approvedByUserId = dto.approvedByUserId
        this.approvedDate = dto.approvedDate ? dayjs(dto.approvedDate) : null
    }
}


export function getRentToBuyChangeTypeLabel(changeType: RentToBuyChangeType): string {
    switch (changeType) {
        case RentToBuyChangeType.newInActive:
            return i18n.t('rentToBuyChecklist.newInActive')
        case RentToBuyChangeType.periodChange:
            return i18n.t('rentToBuyChecklist.periodChange')
        case RentToBuyChangeType.purposeChange:
            return i18n.t('rentToBuyChecklist.purposeChange')
        case RentToBuyChangeType.rentalStageOver:
            return i18n.t('rentToBuyChecklist.rentalStageOver')
        case RentToBuyChangeType.excessiveRentalRate:
            return i18n.t('rentToBuyChecklist.excessiveRentalRate')
        default:
            return changeType
    }
}
